import { Component, OnInit } from '@angular/core';
import { Vehicle } from '../vehicle';
import { VehicleService } from '../vehicle.service';

@Component({
  selector: 'app-vehicle-list',
  template: `

  <section *ngIf="isLoading && !errorMessage">
  Obtaining our data for the vehicles!!! 
  </section>
  <!-- this is the new syntax for ng-repeat -->
  <ul>
    <li *ngFor="let vehicle of vehicle">
      <a [routerLink]="['/vehicles', vehicle.id]">
        {{vehicle.model}} 
      </a>
    </li>
  </ul>
  <!-- HERE: added this error message -->
  <section *ngIf="errorMessage">
    {{errorMessage}}
  </section>
  `,
  styleUrls: ['./vehicle-list.component.scss']
})
export class VehicleListComponent implements OnInit {
  vehicle: Vehicle[] = [];
  errorMessage: string = '';
  isLoading: boolean = true;

  constructor(private vehicleService: VehicleService) { }

  ngOnInit(){
    this.vehicleService
      .getAll()
      .subscribe(
         /* happy path */ v => this.vehicle = v,
         /* error path */ e => this.errorMessage = e,
         /* onCompleted */ () => this.isLoading = false);
  }
}


// WEBPACK FOOTER //
// ./src/app/vehicle-list/vehicle-list.component.ts